export default {
    data: function () {
        return {
            params: {},
            exParams: {},
            items: null,
            meta: null,
            errors: {},
            loading: false,
            url: '/api/items',
            cancelTokenList: {},
        }
    },

    created: function () {
        this.search()
    },

    methods: {
        /**
         * Effectue une recherche
         */
        search: function () {
            return this.get({params: this.params})
        },

        /**
         * Charge une certaine page de la pagination
         * @param page
         */
        goToPage: function (page) {
            this.exParams.page = page
            this.get({params: this.exParams})
        },

        getCancelToken: function (url) {
            if (this.cancelTokenList[url]) {
                this.cancelTokenList[url].cancel()
            }
            this.cancelTokenList[url] = axios.CancelToken.source()

            return this.cancelTokenList[url].token
        },

        /**
         * Efectue la requete avec les paramètres
         * @param params
         */
        get: function (params) {
            this.loading = true
            this.errors = {}

            const config = {
                params: params.params,
                cancelToken: this.getCancelToken(this.$options.url),
            }

            return axios.get(this.$options.url, config).then(response => {
                this.items = response.data.data
                this.meta = response.data.meta
                this.exParams = _.cloneDeep(params.params)
            }).catch(error => {
                this.errors = error.response.data.errors
                this.items = []
                this.meta = {}
            }).finally(() => this.loading = false)
        },

        /**
         * Order by un champ du head
         * @param orderBy
         */
        orderBy: function (orderBy) {
            this.exParams.order = orderBy.order
            this.exParams.direction = orderBy.direction

            this.goToPage(this.meta.current_page)
        },

        /**
         * Afficher n resultats
         */
        paginate: function (numberItems) {
            this.exParams.paginate = numberItems
            this.exParams.page = 1
            this.get({params: this.exParams})
        },

        /**
         * Reffraichit les résultats
         */
        fresh: function () {
            this.get({params: this.exParams})
        }
    },
}
